import { EuiFieldSearch } from '@equipmentshare/ds2'
import { SearchBarProps } from './types'
import useSearchInput from './useSearchInput'

export default function SearchBarEui( props: SearchBarProps ) {
	const { inputVal, setInputVal } = useSearchInput( props )

	const onSearchChange = ( event: React.ChangeEvent<HTMLInputElement> ) => setInputVal( event.currentTarget.value )

	return (
		<EuiFieldSearch
			onChange={onSearchChange}
			value={inputVal}
			placeholder={props.placeholder ?? 'Search'}
			isClearable
		/>
	)
}
